import { _request, APIMethod } from '../';

import * as apiTypes from './LicenseApiTypeDef';

const TENANT_PATH_PREFIX = '/tenants';
const LICENSES_PATH_PREFIX = 'licenses';

export const APILicensesGet: APIMethod<apiTypes.APILicensesGetParams, apiTypes.APILicensesGetResponse> = (params) => (
    _request<apiTypes.APILicensesGetResponse>('GET', `${TENANT_PATH_PREFIX}/${params.tenantId}/${LICENSES_PATH_PREFIX}`, undefined, params.signal)
);

export const APILicenseGet: APIMethod<apiTypes.APILicenseGetParams, apiTypes.APILicenseGetResponse> = (params) => (
    _request<apiTypes.APILicenseGetResponse>('GET', `${TENANT_PATH_PREFIX}/${params.tenantId}/${LICENSES_PATH_PREFIX}/${params.id}`)
);

export const APILicensesPost: APIMethod<apiTypes.APILicensesPostParams, apiTypes.APILicensesPostResponse> = (params) => (
    _request('POST', `${TENANT_PATH_PREFIX}/${params.tenantId}/${LICENSES_PATH_PREFIX}`, params)
);

export const APILicensePut: APIMethod<apiTypes.APILicensesPutParams, apiTypes.APILicensesPutResponse> = (params) => (
    _request('PUT', `${TENANT_PATH_PREFIX}/${params.tenantId}/${LICENSES_PATH_PREFIX}/${params.licenseId}`, {
        tenantId: params.tenantId,
        licenseId: params.licenseId,
        startDate: params.startDate,
        endDate: params.endDate,
        note: params.note,
        billingSystemId: params.billingSystemId,
        billingRecord: params.billingRecord
    })
);

export const APILicenseDelete: APIMethod<apiTypes.APILicenseDeleteParams, apiTypes.APILicenseDeleteResponse> = params => (
    _request<apiTypes.APILicenseDeleteResponse>('DELETE', `${TENANT_PATH_PREFIX}/${params.tenantId}/${LICENSES_PATH_PREFIX}/${params.id}`)
);
